document.addEventListener("DOMContentLoaded", function () {
    const isSoundQuiz = document.querySelector(".sound-quiz");
    if (!isSoundQuiz) return false;

    const startEl = document.querySelector(".start__container");
    const quizContainer = document.querySelector(".sound-quiz__container");

    // Button Elements
    const startBtn = document.querySelector(".start-btn");
    const checkBtn = document.querySelector(".check-btn");
    const nextBtn = document.querySelector(".next-btn");
    const resultsBtn = document.querySelector(".results-btn");
    const shareBtn = document.querySelector(".share-btn");
    const closeModal = document.querySelector(".close-btn");

    // Question Elements
    const questionEl = document.querySelector(".question__container");
    const questionAudio = document.querySelector(".question__audio");
    const playBtn = document.querySelector(".question__audio__button");
    const audio = questionAudio.querySelector("audio");
    const questionOptions = document.querySelector(".question__options");

    // Answer Elements
    const answerEl = document.querySelector(".answer__container");
    const answer = document.querySelectorAll(".answer");
    const answerTitle = document.querySelector(".answer__title");
    const answerText = document.querySelector(".answer__text");

    // Results Elements
    const resultsEl = document.querySelector(".results__container");
    const resultsPoints = document.querySelector(".results__points");
    const resultsConfetti = document.querySelector(".results__confetti");

    let currentQuestionIndex;
    let totalPoints = 0;

    startBtn.addEventListener("click", startGame);
    checkBtn.addEventListener("click", selectAnswer);
    nextBtn.addEventListener("click", () => {
        currentQuestionIndex++;
        setNextQuestion();
    });
    resultsBtn.addEventListener("click", showResults);
    playBtn.addEventListener("click", toggleAudio);

    function startGame() {
        startEl.classList.add("hidden");
        currentQuestionIndex = 0;
        questionEl.classList.remove("hidden");
        setNextQuestion();
    }

    function setNextQuestion() {
        resetState();
        showQuestion(questions[currentQuestionIndex]);
    }

    function showQuestion(question) {
        audio.src = question.audioFile;
        const output = [];

        question.answers.forEach((answer) => {
            const answerOutput = `
                <div class="question__option">
                    <input type="radio" 
                        id="${answer.text}"
                        name="question-${currentQuestionIndex + 1}"
                        value="${answer.text}"
                        ${answer.correct ? 'data-correct="true"' : ""}
                    >
                    <label for="${answer.text}"><span>${answer.text}</span></label>
                </div>
            `;
            output.push(answerOutput);
        });

        questionOptions.innerHTML = output.join("");

        toggleAudio();
    }

    function resetState() {
        clearStatusClass();
        nextBtn.classList.add("hidden");
        while (questionOptions.firstChild) {
            questionOptions.removeChild(questionOptions.firstChild);
        }
    }

    function selectAnswer() {
        const selectedOption = document.querySelector("input:checked");

        if (selectedOption) {
            const correct = selectedOption.dataset.correct;
            setStatusClass(correct);

            // stop audio
            audio.pause();
            audio.currentTime = 0;

            // check if last question
            questions.length > currentQuestionIndex + 1 ? nextBtn.classList.remove("hidden") : resultsBtn.classList.remove("hidden");
        }
    }

    function setStatusClass(correct) {
        let correctAnswer;
        [...questionOptions.children].forEach((option) => {
            const inputEl = option.querySelector("input");
            if (inputEl.dataset.correct) correctAnswer = inputEl.value;
        });

        answer.forEach((el) => (el.innerHTML = correctAnswer));
        answerTitle.innerHTML = questions[currentQuestionIndex].title;
        answerText.innerHTML = questions[currentQuestionIndex].text;

        clearStatusClass();

        questionEl.classList.add("hidden");
        answerEl.classList.remove("hidden");

        if (correct) {
            quizContainer.classList.add("correct");
            totalPoints++;
        } else {
            quizContainer.classList.add("incorrect");
        }
    }

    function clearStatusClass() {
        quizContainer.classList.remove("correct");
        quizContainer.classList.remove("incorrect");
        answerEl.classList.add("hidden");
        questionEl.classList.remove("hidden");
        playBtn.classList.remove("playing");
    }

    function showResults() {
        answerEl.classList.add("hidden");
        resultsBtn.classList.add("hidden");
        resultsEl.classList.remove("hidden");

        if (totalPoints > questions.length / 2) {
            resultsEl.classList.add("good");
            resultsConfetti.style.visibility = "visible";
            renderConfetti();
        } else {
            resultsEl.classList.add("bad");
        }

        resultsPoints.innerHTML = `Endergebnis: ${totalPoints} von ${questions.length} Punkten`;
    }

    function toggleAudio() {
        audio.paused ? audio.play() : audio.pause();
        playBtn.classList.toggle("playing");
        audio.onended = () => playBtn.classList.toggle("playing");
    }

    shareBtn.addEventListener("click", () => {
        resultsEl.classList.add("share-buttons--opened");
    });

    closeModal.addEventListener("click", () => {
        resultsEl.classList.remove("share-buttons--opened");
    });

    // social media share
    const facebook = document.querySelector(".facebook");
    const twitter = document.querySelector(".twitter");
    const whatsapp = document.querySelector(".whatsapp");

    const pageUrl = location.href;
    const message = "Gehen Sie mit audibene auf eine akustische Reise durch Deutschland. Testen Sie jetzt, ob Sie jedes Geräusch erkennen und richtig zuordnen können!";

    const facebookApi = `https://www.facebook.com/sharer.php?u=${pageUrl}`;
    const twitterApi = `https://twitter.com/intent/tweet?text=${pageUrl} . ${message}`;
    const whatsappApi = `https://wa.me/?text=${pageUrl} . ${message}`;

    facebook.addEventListener("click", () => {
        window.open(facebookApi, "blank");
    });

    twitter.addEventListener("click", () => {
        window.open(twitterApi, "blank");
    });

    whatsapp.addEventListener("click", () => {
        window.open(whatsappApi, "blank");
    });

    // Confetti
    // ammount to add on each button press
    const confettiCount = 30;
    const sequinCount = 20;

    // "physics" variables
    const gravityConfetti = 0.3;
    const gravitySequins = 0.55;
    const dragConfetti = 0.075;
    const dragSequins = 0.02;
    const terminalVelocity = 3;

    // init other global elements
    const canvas = document.getElementById("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;
    let cx = ctx.canvas.width;
    let cy = ctx.canvas.height;

    // add Confetto/Sequin objects to arrays to draw them
    let confetti = [];
    let sequins = [];

    // colors, back side is darker for confetti flipping
    const colors = [
        { front: "#6cb0e2", back: "#5081a6" }, // Blue
        { front: "#b1b84f", back: "#939942" }, // Green
    ];

    // helper function to pick a random number within a range
    const randomRange = (min, max) => Math.random() * (max - min) + min;

    // helper function to get initial velocities for confetti
    // this weighted spread helps the confetti look more realistic
    const initConfettoVelocity = (xRange, yRange) => {
        const x = randomRange(xRange[0], xRange[1]);
        const range = yRange[1] - yRange[0] + 1;
        let y = yRange[1] - Math.abs(randomRange(0, range) + randomRange(0, range) - range);
        if (y >= yRange[1] - 1) {
            // Occasional confetto goes higher than the max
            y += Math.random() < 0.25 ? randomRange(1, 3) : 0;
        }
        return { x: x, y: -y };
    };

    // Confetto Class
    function Confetto() {
        this.randomModifier = randomRange(0, 99);
        this.color = colors[Math.floor(randomRange(0, colors.length))];
        this.dimensions = {
            x: randomRange(5, 9),
            y: randomRange(8, 15),
        };
        this.position = {
            x: randomRange(canvas.width / 2, canvas.width / 2),
            y: randomRange(canvas.height / 2, canvas.height / 2),
        };
        this.rotation = randomRange(0, 2 * Math.PI);
        this.scale = {
            x: 1,
            y: 1,
        };
        this.velocity = initConfettoVelocity([-9, 9], [6, 11]);
    }
    Confetto.prototype.update = function () {
        // apply forces to velocity
        this.velocity.x -= this.velocity.x * dragConfetti;
        this.velocity.y = Math.min(this.velocity.y + gravityConfetti, terminalVelocity);
        this.velocity.x += Math.random() > 0.5 ? Math.random() : -Math.random();

        // set position
        this.position.x += this.velocity.x;
        this.position.y += this.velocity.y;

        // spin confetto by scaling y and set the color, .09 just slows cosine frequency
        this.scale.y = Math.cos((this.position.y + this.randomModifier) * 0.09);
    };

    // Sequin Class
    function Sequin() {
        (this.color = colors[Math.floor(randomRange(0, colors.length))].back),
            (this.radius = randomRange(1, 2)),
            (this.position = {
                x: randomRange(canvas.width / 2, canvas.width / 2),
                y: randomRange(canvas.height / 2, canvas.height / 2),
            }),
            (this.velocity = {
                x: randomRange(-6, 6),
                y: randomRange(-8, -12),
            });
    }
    Sequin.prototype.update = function () {
        // apply forces to velocity
        this.velocity.x -= this.velocity.x * dragSequins;
        this.velocity.y = this.velocity.y + gravitySequins;

        // set position
        this.position.x += this.velocity.x;
        this.position.y += this.velocity.y;
    };

    // add elements to arrays to be drawn
    function initBurst() {
        for (let i = 0; i < confettiCount; i++) {
            confetti.push(new Confetto());
        }
        for (let i = 0; i < sequinCount; i++) {
            sequins.push(new Sequin());
        }
    }

    let animationCounter = 0;

    // draws the elements on the canvas
    const renderConfetti = () => {
        ctx.clearRect(0, 0, canvas.width, canvas.height);

        confetti.forEach((confetto, index) => {
            let width = confetto.dimensions.x * confetto.scale.x;
            let height = confetto.dimensions.y * confetto.scale.y;

            // move canvas to position and rotate
            ctx.translate(confetto.position.x, confetto.position.y);
            ctx.rotate(confetto.rotation);

            // update confetto "physics" values
            confetto.update();

            // get front or back fill color
            ctx.fillStyle = confetto.scale.y > 0 ? confetto.color.front : confetto.color.back;

            // draw confetto
            ctx.fillRect(-width / 2, -height / 2, width, height);

            // reset transform matrix
            ctx.setTransform(1, 0, 0, 1, 0, 0);
        });

        sequins.forEach((sequin, index) => {
            // move canvas to position
            ctx.translate(sequin.position.x, sequin.position.y);

            // update sequin "physics" values
            sequin.update();

            // set the color
            ctx.fillStyle = sequin.color;

            // draw sequin
            ctx.beginPath();
            ctx.arc(0, 0, sequin.radius, 0, 2 * Math.PI);
            ctx.fill();

            // reset transform matrix
            ctx.setTransform(1, 0, 0, 1, 0, 0);
        });

        // remove confetti and sequins that fall off the screen
        // must be done in seperate loops to avoid noticeable flickering
        confetti.forEach((confetto, index) => {
            if (confetto.position.y >= canvas.height) confetti.splice(index, 1);
        });
        sequins.forEach((sequin, index) => {
            if (sequin.position.y >= canvas.height) sequins.splice(index, 1);
        });

        if (animationCounter < 250) {
            window.requestAnimationFrame(renderConfetti);
            animationCounter++;
        }
    };

    // re-init canvas if the window size changes
    const resizeCanvas = () => {
        canvas.width = window.innerWidth;
        canvas.height = window.innerHeight;
        cx = ctx.canvas.width / 2;
        cy = ctx.canvas.height / 2;
    };

    // resize listenter
    window.addEventListener("resize", () => {
        resizeCanvas();
    });

    // kick off the render loop
    initBurst();
});

const questions = [
    {
        audioFile: "https://res.cloudinary.com/dhqvlsb3l/video/upload/v1/SEO%20WEBSITE/assets/2022_sounds-of-germany/audio/So_klingt_Deutschland_Sound_Nordsee.aac",
        answers: [
            { text: "Chiemsee", correct: false },
            { text: "Rhein", correct: false },
            { text: "Nordsee", correct: true },
        ],
        title: "Moin an der Nordseeküste!",
        text: "Hier erleben Sie raue Natur und kilometerlange Badestrände.",
    },
    {
        audioFile: "https://res.cloudinary.com/dhqvlsb3l/video/upload/v1/SEO%20WEBSITE/assets/2022_sounds-of-germany/audio/So_klingt_Deutschland_Sound_Schwarzwald.aac",
        answers: [
            { text: "Schwarzwald", correct: true },
            { text: "Müritz", correct: false },
            { text: "Röhn", correct: false },
        ],
        title: "Willkommen im Schwarzwald.",
        text: "Der Südwesten Deutschlands ist ein Paradies für Naturliebhaber.",
    },
    {
        audioFile: "https://res.cloudinary.com/dhqvlsb3l/video/upload/v1/SEO%20WEBSITE/assets/2022_sounds-of-germany/audio/So_klingt_Deutschland_Sound_Allga%CC%88u.aac",
        answers: [
            { text: "Lüneburger Heide", correct: false },
            { text: "Taunus", correct: false },
            { text: "Allgäu", correct: true },
        ],
        title: "Oh, wie schön ist Süddeutschland!",
        text: "Genießen Sie die Idylle der Berge, den Geruch von Freiheit und malerische Märchenschlösser.",
    },
    {
        audioFile: "https://res.cloudinary.com/dhqvlsb3l/video/upload/v1/SEO%20WEBSITE/assets/2022_sounds-of-germany/audio/So_klingt_Deutschland_Sound_Mosel.aac",
        answers: [
            { text: "Spree", correct: false },
            { text: "Mosel", correct: true },
            { text: "Elbe", correct: false },
        ],
        title: "Auf ein Tröpfchen an die Mosel.",
        text: "Auch gut: Wandern und Radfahren zwischen grünen Weinbergen!",
    },
    {
        audioFile: "https://res.cloudinary.com/dhqvlsb3l/video/upload/v1/SEO%20WEBSITE/assets/2022_sounds-of-germany/audio/So_klingt_Deutschland_Sound_Harz.aac",
        answers: [
            { text: "Sächsische Schweiz", correct: false },
            { text: "Spessart", correct: false },
            { text: "Harz", correct: true },
        ],
        title: "Wie verhext! Der Harz an Walpurgis.",
        text: "Im Sommer kommen Wanderer, im Winter Pistenjäger und in der Nacht zum 1. Mai Hexen.",
    },
    {
        audioFile: "https://res.cloudinary.com/dhqvlsb3l/video/upload/v1/SEO%20WEBSITE/assets/2022_sounds-of-germany/audio/So_klingt_Deutschland_Sound_Wolfsburg.aac",
        answers: [
            { text: "Wolfratshausen", correct: false },
            { text: "Wolfsburg", correct: true },
            { text: "Ingolstadt", correct: false },
        ],
        title: "So klingt Deutschlands liebstes Kind.",
        text: "In die Autostadt Wolfsburg kommen die einen zum Staunen und andere holen ihr neues „Baby“ ab.",
    },
    {
        audioFile: "https://res.cloudinary.com/dhqvlsb3l/video/upload/v1/SEO%20WEBSITE/assets/2022_sounds-of-germany/audio/So_klingt_Deutschland_Sound_Berlin.aac",
        answers: [
            { text: "Berlin", correct: true },
            { text: "Bremen", correct: false },
            { text: "Bad Belzig", correct: false },
        ],
        title: "Berlin, du klingst so wunderbar!",
        text: "In die Hauptstadt kommen Besucher zum Sightseeing, Feiern oder zum Staatsbesuch.",
    },
    {
        audioFile: "https://res.cloudinary.com/dhqvlsb3l/video/upload/v1/SEO%20WEBSITE/assets/2022_sounds-of-germany/audio/So_klingt_Deutschland_Sound_Rheinland.aac",
        answers: [
            { text: "Sauerland", correct: false },
            { text: "Havelland", correct: false },
            { text: "Rheinland", correct: true },
        ],
        title: "Jeck im Rheinland",
        text: "Hier zählt nur eine Jahreszeit: der Karneval. Er startet am 11.11 und geht dann gefühlt ein ganzes Jahr.",
    },
    {
        audioFile: "https://res.cloudinary.com/dhqvlsb3l/video/upload/v1/SEO%20WEBSITE/assets/2022_sounds-of-germany/audio/So_klingt_Deutschland_Sound_Ruhrgebiet.aac",
        answers: [
            { text: "Ruhrgebiet", correct: true },
            { text: "Brandenburg", correct: false },
            { text: "Saarland", correct: false },
        ],
        title: "Chor ohne Kirche",
        text: "Im Ruhrgebiet pilgern Hunderttausende am Wochenende an einen ganz besonderen Ort: das Fußballstadion.",
    },
    {
        audioFile: "https://res.cloudinary.com/dhqvlsb3l/video/upload/v1/SEO%20WEBSITE/assets/2022_sounds-of-germany/audio/So_klingt_Deutschland_Sound_M%C3%BCnchen.aac",
        answers: [
            { text: "Mannheim", correct: false },
            { text: "München", correct: true },
            { text: "Mönchengladbach", correct: false },
        ],
        title: "Das klingt nach Gaudi",
        text: "Das Oktoberfest in München ist das größte Volksfest der Welt.",
    },
];
